export default __webpack_public_path__ + "static/media/Background_00242.8f2f6b65.png";